exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#consecutive-lessons table td[data-v-30333b86]{font-size:11pt}#consecutive-lessons .table-container[data-v-30333b86]{height:225px;overflow-y:scroll}#consecutive-lessons .table thead th[data-v-30333b86]{position:sticky;top:0}", ""]);

// exports
